import * as runtypes from 'runtypes';
import * as visibleInstitution from 'src/models/visibleInstitution';

export const VisibleInstitutionRecord = runtypes.Dictionary(
  visibleInstitution.types.VisibleInstitution,
  runtypes.String
);

export type VisibleInstitutionRecord = runtypes.Static<typeof VisibleInstitutionRecord>;
